module.exports = __webpack_public_path__ + "static/team-c0c14ee99576af374822c1122cc87e85.svg";